import { useState } from 'react';
import { saveEspnCredentials } from '../services/api';

/**
 * Modal for entering ESPN's SWID and espn_s2 cookies. ESPN has no OAuth flow --
 * the user copies these two values from their browser's DevTools after logging
 * into fantasy.espn.com.
 *
 * @param {Function} onClose - Called to dismiss the modal without saving
 * @param {Function} onSaved - Called after credentials are successfully saved
 */
function EspnCredentialModal({ onClose, onSaved }) {
  const [swid, setSwid] = useState('');
  const [espnS2, setEspnS2] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (!swid.trim()) {
      setError('SWID is required');
      return;
    }
    if (!espnS2.trim()) {
      setError('espn_s2 is required');
      return;
    }

    setSaving(true);
    try {
      await saveEspnCredentials(swid.trim(), espnS2.trim());
      onSaved();
    } catch (err) {
      const msg = err.response?.data?.error?.message || err.message;
      setError(msg);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal' onClick={(e) => e.stopPropagation()}>
        <h2>Connect ESPN Account</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
          ESPN doesn't support one-click sign-in. Log into fantasy.espn.com, open your
          browser's DevTools (F12) → Application/Storage → Cookies → fantasy.espn.com,
          then copy the <code>SWID</code> and <code>espn_s2</code> cookie values below.
        </p>
        {error && <div className='error-banner'>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label>SWID</label>
            <input
              type='text'
              className='input'
              style={{ width: '100%' }}
              placeholder='{XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX}'
              value={swid}
              onChange={(e) => setSwid(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label>espn_s2</label>
            <input
              type='text'
              className='input'
              style={{ width: '100%' }}
              placeholder='Long alphanumeric string'
              value={espnS2}
              onChange={(e) => setEspnS2(e.target.value)}
            />
          </div>
          <div className='modal-actions'>
            <button type='button' className='btn btn-secondary' onClick={onClose}>
              Cancel
            </button>
            <button type='submit' className='btn btn-primary' disabled={saving}>
              {saving ? 'Saving…' : 'Connect'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EspnCredentialModal;
